import { toClsMetric } from './cls';
import { toInpMetric } from './inp';
import { toLcpMetric } from './lcp';
import { toTtfbMetric } from './ttfb';
import { toFcpMetric } from './fcp';
export const metricsMapper = {
    INP: toInpMetric,
    CLS: toClsMetric,
    LCP: toLcpMetric,
    TTFB: toTtfbMetric,
    FCP: toFcpMetric,
};
//# sourceMappingURL=index.js.map